<template>
  <div class="search-results">
    <c-search-results-article
      v-for="article,index in articles"
      :key="article.id"
      v-bind="article"
      :index="index"
      @keyup.native.esc="stopinfiniteloading"
      @keyup.native.tab="startinfinateLoading"
    >
  </c-search-results-article>
  <!-- <c-vs-advert v-if="articles.length<4"><br/></c-vs-advert> -->
    <infinite-loading v-if="canLoadMore"  @infinite="infiniteHandler" spinner="circles" ref="spinnerInfiniteLoad">
      <template v-slot:spinner>
        <div class="loadingSpinnerContainer" ref="spinnerIconInfiniteLoad" >
          <div class="loading-spinner loadingSpinner">
            <i class="fa fa-spinner spinner"></i>
          </div>
          <p class="loading-spinner__msg loadingSpinnerMessage">Loading</p>
        </div>
      </template>
    </infinite-loading>
  </div>
</template>

<script>
import SearchResultsArticle from '@/components/pages/searchResults/SearchResultsArticle.vue'
// import VSadvert from '@/components/pages/searchResults/VSadvert.vue'

var infiniteLoadToggle = true;
export default {
  components: { 'c-search-results-article': SearchResultsArticle,
  // 'c-vs-advert':VSadvert
 },
  props: { articles: { required: true, type: Array } },
  computed: {
    canLoadMore() {
      const availableArticles = Number(this.$store.getters['search/results']?.data?.numFound) || 0
      return this.articles.length < availableArticles
    }
  },
  methods: {
    stopinfiniteloading(e){
     // send focus to the footer and disable infiniteload
     infiniteLoadToggle=false
     console.log(this.$refs.spinnerIconInfiniteLoad.style="display:none")
     this.$refs.spinnerIconInfiniteLoad.style="display:none"
      document.querySelector("#firstFooterElement").focus()
    },
    startinfinateLoading(e){
      if(!infiniteLoadToggle){
        infiniteLoadToggle=true
        // this.$refs.spinnerInfiniteLoad.$el.style=""
        this.$refs.spinnerIconInfiniteLoad.style=""
        this.$refs.spinnerInfiniteLoad.stateChanger.loaded()
      }
      infiniteLoadToggle=true
    },
    infiniteHandler(e) {
      if(infiniteLoadToggle){
      this.$emit('infinite', e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loadingSpinnerContainer {
  padding: 1rem;
  text-align: center;
  width: 100%;
  .loadingSpinnerMessage {
    width: 100% !important;
  }
  .loadingSpinner {
    width: 100% !important;
  }
}
</style>
